module.exports = __webpack_public_path__ + "static/img/title.d863e9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/read/title.png
// module id = RAwQ
// module chunks = 0